import React, { useMemo, useRef, useState } from 'react'
import { Page, Title, Alert } from '~/components'
import FinanceService from '~/services/FinanceService'
import { withCamim } from '~/utils/withAuth'
import { useEffect } from 'react'
import { utils } from '~/utils/Utils'
import FinanceView from './FinanceView'
import FinanceMobileView from './FinanceView/mobile'

function FinanceHash({
    match: {
        params: { hash },
    },
    ...props
}) {
    const { isMobile } = props
    const [error, setError] = useState()
    const [loading, setLoading] = useState(true)
    const [creditCardReceitas, setCreditCardReceitas] = useState([])
    const [data, setData] = useState()

    const serviceRef = useRef(new FinanceService(props))

    const code = useMemo(() => utils.getFilialCodeFromHash(hash), [hash])

    const finances = useMemo(() => {
        return data ? data.finances : []
    }, [data])

    async function handleLogin() {
        try {
            const filial = props.filials.find(e => e.code === code)
            if (!filial) {
                setError('Hash inválido')
                return
            }
            const { result } = await serviceRef.current.loginWithFinance(
                hash,
                filial
            )
            setData(result)
        } catch (error) {
            setError(
                error.message ||
                    error.error ||
                    'Erro ao realizar a autenticação'
            )
        } finally {
            setLoading(false)
        }
    }

    async function createInvoice(finance) {
        const index = finances.findIndex(
            item => item.idReceita === finance.idReceita
        )
        const idReceitas = []
        for (let x = 0; x <= index; x++) {
            idReceitas.push(finances[x].idReceita)
        }
        const { idReceita } = finance
        const values = {
            idReceitas,
            ...data.customer,
        }
        try {
            setError(undefined)
            setCreditCardReceitas([idReceita])
            const response = await fetch(
                `https://api.camim.com.br/finance/segunda-via/credit-card`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(values),
                }
            )
            const json = await response.json()
            if (!response.ok) {
                throw new Error(
                    json.error ||
                        json.message ||
                        'Não foi possível criar a fatura'
                )
            }
            setCreditCardReceitas([])
            if (isMobile) {
                window.location.href = json.link
            } else {
                window.open(json.link)
            }
        } catch (error) {
            setError(error.message || error.error || 'Erro ao criar fatura')
        }
    }

    useEffect(() => {
        if (code) {
            handleLogin()
        }
    }, [code])

    return (
        <Page title="Financeiro" hideBreadcrumb>
            <Title success underline>
                Financeiro
            </Title>
            {error && <Alert danger>{error}</Alert>}
            {loading && (
                <Alert warning requesting>
                    Autenticando...
                </Alert>
            )}
            {data?.customer && (
                <div className="mt-2">
                    <div>
                        Nome:{' '}
                        <span className="font-bold">{data.customer.name}</span>
                    </div>
                    <div>
                        Matrícula:{' '}
                        <span className="font-bold">
                            {data.customer.matricula}
                        </span>
                    </div>
                </div>
            )}
            {!!finances.length && (
                <>
                    {!isMobile ? (
                        <FinanceView
                            finances={finances}
                            onCreateInvoice={createInvoice}
                            processingReceitaIds={creditCardReceitas}
                        />
                    ) : (
                        <FinanceMobileView
                            finances={finances}
                            onCreateInvoice={createInvoice}
                            processingReceitaIds={creditCardReceitas}
                        />
                    )}
                </>
            )}
        </Page>
    )
}

export default withCamim(FinanceHash)
